// pages/Register.js
import SignUpForm from "../components/RegisterScreen/SignUpForm";
import Footer from "../components/HomeScreen/Footer";

const Register = () => {
  return (
    <>
      <SignUpForm />
      <Footer />
    </>
  );
}
export default Register;
